import Unbind from './Unbind'
import Logout from './Logout'
import Bindtips from './Bindtips'
import Tip from './Tip'
import AccLeave from './AccLeave'
import NoMargin from './NoMargin'
import AboutMargin from './AboutMargin'
import SaleDes from './SaleDes'
import NoRole from './NoRole'
import Accounts from './Accounts'
import Margin from './Margin'
import DbDes from './DbDes'
import EditPrice from './EditPrice'
import CancelOrder from './CancelOrder'
import Key from './Key'
import ServiceFee from './ServiceFee'
import UnbindAlipay from './UnbindAlipay'
import ServiceFeeDes from './ServiceFeeDes'
import ConsignmentDes from './ConsignmentDes'
import BindGameacc from './BindGameacc'
import BindGameacc2 from './BindGameacc2'
import DownGoodsConfirm from './DownGoodsConfirm'
import CantDown from './CantDown'

export default {
    unbind: {
        title: '',
        FormTemplate: Unbind
    },
    logout: {
        title: '',
        FormTemplate: Logout
    },
    bindtips: {
        title: '',
        FormTemplate: Bindtips
    },
    tip: {
        title: '',
        FormTemplate: Tip
    },
    accleave: {
        title: '',
        FormTemplate: AccLeave
    },
    nomargin: {
        title: '',
        FormTemplate: NoMargin
    },
    aboutmargin: {
        title: '',
        FormTemplate: AboutMargin
    },
    saledes: {
        title: '',
        FormTemplate: SaleDes
    },
    norole: {
        title: '',
        FormTemplate: NoRole
    },
    accounts: {
        title: '',
        FormTemplate: Accounts
    },
    margin: {
        title: '',
        FormTemplate: Margin
    },
    dbdes: {
        title: '',
        FormTemplate: DbDes
    },
    editprice: {
        title: '',
        FormTemplate: EditPrice
    },
    cancelorder: {
        title: '',
        FormTemplate: CancelOrder
    },
    key: {
        title: '',
        FormTemplate: Key
    },
    servicefee: {
        title: '',
        FormTemplate: ServiceFee
    },
    servicefeedes: {
        title: '',
        FormTemplate: ServiceFeeDes
    },
    consignmentdes: {
        title: '',
        FormTemplate: ConsignmentDes
    },
    unbindalipay: {
        title: '',
        FormTemplate: UnbindAlipay
    },
    bindgameacc: {
        title: '',
        FormTemplate: BindGameacc
    },
    bindgameacc2: {
        title: '',
        FormTemplate: BindGameacc2
    },
    downgoodsconfirm: {
        title: '',
        FormTemplate: DownGoodsConfirm
    },
    cantdown: {
        title: '',
        FormTemplate: CantDown
    }
}